'use client'

import { useTokenRefresh } from '@/hooks/useTokenRefresh'

export function AuthSession() {
  useTokenRefresh()
  return null
}